import { TextureLoader, OrthographicCamera, Scene, WebGLRenderer, Color, SRGBColorSpace, PlaneGeometry, Mesh } from "three";
import { debounce } from "../../../utils";
import Effect from "./Effect";
import { gsap } from 'gsap';

class AiA16zPodcastScene {
    static init = () => {
        const wrapper = document.getElementById('ai-a16z--hero');

        if (!wrapper) return;

        const tunnel = new AiA16zPodcastScene(wrapper);
    }

    constructor(el) {
        this.el = el;
        this.hero = document.getElementById('ai-a16z--hero');
        this.contnetLeft = this.hero.querySelector('.left');
        this.contnetRight = this.hero.querySelector('.right');
        this.effects = new Effect();
        this.setSizes();
        this.initBindings();
        this.initLoader();
    }

    initBindings() {
        this.onResize = this.onResize.bind(this);
        this.render = this.render.bind(this);
    }

    setSizes () {
        this.sizes = {
            width: this.el.clientWidth,
            height: this.el.clientHeight,
            dpr: Math.min(window.devicePixelRatio, 2),
            aspectRatio: this.el.clientWidth / this.el.clientHeight
        }
    }

    initLoader (){
        this.loader = new TextureLoader();

        this.images = {}

        this.loader.load(`${window.assets_url}/images/podcast/ai-a16z-podcast-cover.jpg`, (texture) => {
            texture.colorSpace = SRGBColorSpace;
            texture.customData = {
                width: texture.image.width,
                height: texture.image.height
            }
            this.images.banner = texture;

            this.onLoad();
        });
    }

    onLoad () {
        this.initialize();
    }

    createScene () {
        this.scene = new Scene();
        this.scene.background = new Color(0x0a1044);
    }

    createCamera () {
        // orthographic camera for 2D el size
        this.camera = new OrthographicCamera(
            this.sizes.width / -2,
            this.sizes.width / 2,
            this.sizes.height / 2,
            this.sizes.height / -2,
            1,
            1000
        );

        this.camera.position.z = 1;
    }

    createRenderer () {
        this.renderer = new WebGLRenderer({
            alpha: true,
            antialias: true,
        });
        this.renderer.setSize(this.sizes.width, this.sizes.height);
        this.renderer.setPixelRatio(this.sizes.dpr);

        this.el.appendChild(this.renderer.domElement);
    }

    addObjects() {
        const sceneWidth = this.sizes.width;
        const sceneHeight = this.sizes.height;

        const planeGeometry = new PlaneGeometry(sceneWidth, sceneHeight, 1, 1);

        this.material = this.createMaterial();
        const plane = new Mesh(planeGeometry, this.material);

        this.scene.add(plane);
    }

    calcResolution () {
        const { width, height } = this.sizes;
        const imageAspect = this.images.banner.image.height / this.images.banner.image.width;
        let a1;
        let a2;
        if (height / width > imageAspect) {
            a1 = (width / height) * imageAspect;
            a2 = 1;
        } else {
            a1 = 1;
            a2 = height / width / imageAspect;
        }
        console.log(this.images.banner.image.width, this.images.banner.image.height)
        console.log({ x: width, y: height, z: a1, w: a2 });
        return { x: width, y: height, z: a1, w: a2 };
    }

    createMaterial () {
        const material = this.effects.getMaterial();

        material.uniforms.uTexture = {
            value: this.images.banner
        }

        material.uniforms.uColor.value = new Color('#0a1044');
        material.uniforms.uResolution.value = this.calcResolution();
        material.transparent = true;

        return material;
    }

    playEffect () {
        this.material.uniforms.uProgress.value = 0;

        this.timeline = gsap.timeline()

        .to(this.material.uniforms.uProgress, {
            duration: 2,
            value: 1,
            ease: 'none'
        })
            .to(this.contnetLeft, {
                duration: 1.5,
                opacity: 1,
                ease: 'none'
            }, 0.1)

            .to(this.contnetRight, {
                duration: 1.5,
                opacity: 1,
                ease: 'none'
            }, 1)
    }

    render () {
        requestAnimationFrame(this.render);
        this.renderer.render(this.scene, this.camera);
    }

    addListeners () {
        window.addEventListener('resize', debounce(this.onResize, 100));
    }

    onResize () {
        if(this.sizes.width !== this.el.clientWidth || this.sizes.height !== this.el.clientHeight) {
            this.resize();
        }
    }

    resize () {
        this.setSizes();
        this.camera.aspect = this.sizes.aspectRatio;
        this.camera.updateProjectionMatrix();
        this.renderer.setSize(this.sizes.width, this.sizes.height);
        this.resizeObjects()
    }

    resizeObjects () {
        const material = this.scene.children[0].material;
        material.uniforms.uResolution.value = this.calcResolution();
    }

    initialize () {
        this.createScene();
        this.createCamera();
        this.createRenderer();
        this.addObjects();
        this.addListeners();
        this.playEffect()
        this.render();
    }
}

export default AiA16zPodcastScene;
